import React, { useEffect, useRef, useState } from "react";
import Categories from "layout/dictionarySearch/folder/byFolder/categories";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "slices/dictionarySearch/actions/categories";
import Documents from "layout/dictionarySearch/folder/byFolder/documents";
import SplitPane from "react-split-pane";
import Pane from "react-split-pane/lib/Pane";
import ContentPanel from "layout/dictionarySearch/content/ContentPanel";
import { checkedTypes } from "constants/types";
import { folderBy } from "layout/dictionarySearch/constants";

const ByFolder = () => {
  const dispatch = useDispatch();
  const categoriesRef = useRef();
  const documentsRef = useRef();
  const categoriesListRef = useRef();
  const documentsListRef = useRef();
  const nestedSplitPaneRef = useRef();
  const [hoveredRow, setHoveredRow] = useState(-1);
  const [categoriesSize, setCategoriesSize] = useState("20%");
  const [docsSize, setDocsSize] = useState("300px");
  const [nestedSplitPaneSize, setNestedSplitPaneSize] = useState("80%");
  const { categories } = useSelector(
    (state) => state.dictionarySearch.folder.dictionary
  );
  const documents = useSelector(
    (state) => state.dictionarySearch.folder.documents
  );

  const handleDragRelease = () => {
    if (categoriesListRef && categoriesListRef.current) {
      setCategoriesSize(categoriesListRef.current.props.size);
      setNestedSplitPaneSize(
        `${100 - parseFloat(categoriesListRef.current.props.size)}%`
      );
    }

    if (documentsListRef && documentsListRef.current) {
      setDocsSize(documentsListRef.current.props.size);
    }
  };

  const checkedItems = categories
    ?.map((c) => c.items?.filter((i) => i.checkState === checkedTypes.CHECKED))
    .flat(1)
    .map((i) => i?.id);

  const docList = documents
    ?.filter((d) => d.checkState === checkedTypes.CHECKED)
    .map((d) => ({
      docName: d.name,
      selectedTerms: checkedItems,
    }))
    .filter((doc) => doc.selectedTerms.length);

  const styles = {
    background: "transparent",
    width: "1px",
    cursor: "col-resize",
    height: "100%",
    paddingRight: "2px",
    borderRight: "transparent 4px solid",
    borderLeft: "transparent 4px solid",
    margin: "0 -5px",
    zIndex: "1",
  };

  useEffect(() => {
    dispatch(fetchCategories(folderBy.folder));
    window.addEventListener("mouseup", handleDragRelease);
    return () => {
      window.removeEventListener("mouseup", handleDragRelease);
    };
  }, [dispatch]);

  return (
    <SplitPane
      className="dictionary_search__folder__by_folder"
      style={{ position: "relative", overflow: "hidden" }}
      split="vertical"
      resizerStyle={styles}
    >
      <Pane
        ref={categoriesListRef}
        minSize="220px"
        initialSize={categoriesSize}
        className="dictionary_search__folder__by_folder-left"
      >
        <Categories categoriesRef={categoriesRef} documentsRef={documentsRef} />
      </Pane>
      <Pane
        ref={nestedSplitPaneRef}
        minSize="200px"
        className="nested-SplitPane-pane"
        initialSize={nestedSplitPaneSize}
      >
        <SplitPane
          className="nested-SplitPane"
          style={{ position: "relative", overflow: "hidden" }}
        >
          <Pane
            ref={documentsListRef}
            minSize="200px"
            initialSize={docsSize}
            className="dictionary_search__folder__by_folder-middle"
          >
            <Documents
              categoriesRef={categoriesRef}
              documentsRef={documentsRef}
              hoveredRow={hoveredRow}
              setHoveredRow={setHoveredRow}
            />
          </Pane>
          <Pane
            minSize="200px"
            className="dictionary_search__folder__by_folder-right"
          >
            <ContentPanel docItemsArray={docList} />
          </Pane>
        </SplitPane>
      </Pane>
    </SplitPane>
  );
};

export default ByFolder;
